import React, { useState } from 'react';
import { ChevronDownIcon, EyeOffIcon } from 'lucide-react';
import type { FieldGroup } from '../../types/disclosure';
interface NotApplicableGroupsProps {
  groups: FieldGroup[];
  sectionId: string;
}
export function NotApplicableGroups({
  groups,
  sectionId
}: NotApplicableGroupsProps) {
  const [open, setOpen] = useState(false);
  if (groups.length === 0) return null;
  return <div className="rounded-md border border-dashed border-slate-200 bg-slate-50/70" data-id="element-24" data-mp="8lrgrqdt98zv">
      <button type="button" aria-expanded={open} aria-controls={`${sectionId}-na-panel`} onClick={() => setOpen(value => !value)} className="flex w-full items-center justify-between gap-3 px-3 py-2 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-600" data-id="element-25" data-mp="dl44segf4m41">
        <span className="flex min-w-0 items-center gap-2" data-id="element-26" data-mp="1u05c9jx2mg49">
          <EyeOffIcon className="h-3.5 w-3.5 shrink-0 text-slate-400" aria-hidden="true" data-id="element-27" data-mp="1y1qu7jogpklb" />
          <span className="text-xs text-slate-500" data-id="element-28" data-mp="2q2ze22dfusxh">
            <span className="font-semibold text-slate-600" data-id="element-29" data-mp="2q1oc883jzv90">
              {groups.length} conditional {groups.length === 1 ? 'group' : 'groups'} did not apply
            </span>
            <span className="hidden sm:inline" data-id="element-30" data-mp="2zrzfrtjbs2fd"> — {groups.map(group => group.title).join(', ')}</span>
          </span>
        </span>
        <ChevronDownIcon className={`h-4 w-4 shrink-0 text-slate-400 transition-transform ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-31" data-mp="2uwakw3i939pe" />
      </button>

      {open && <ul id={`${sectionId}-na-panel`} className="space-y-2 border-t border-slate-200 px-3 py-2" data-id="element-32" data-mp="227wo1r2wejff">
          {groups.map(group => <li key={group.id} data-id="element-33" data-mp="2c3gie91tda22">
              <p className="text-xs font-semibold text-slate-600" data-id="element-34" data-mp="2c254vhikgnxr">
                {group.title}
                {group.condition && <span className="ml-2 font-normal text-slate-400" data-id="element-35" data-mp="3sk2l76clur17">({group.condition})</span>}
              </p>
              {group.applicabilityNote && <p className="text-xs text-slate-500" data-id="element-36" data-mp="3ul1nctbwj51f">{group.applicabilityNote}</p>}
              <p className="text-xs text-slate-400" data-id="element-37" data-mp="3eqsjexhj0ij">{group.fields.map(field => field.label).join(' · ')}</p>
            </li>)}
        </ul>}
    </div>;
}